import {Row} from 'antd';
import classes from '../Pages.module.css';
import DataField from './DataField';
import DependentEdit from './DependentEdit';

const Dependent = (props) => {
    return(
        !props.editMode
        ?
        props.data.map((data, index) => {
            return(
                <div key={index}>
                <p></p>
                <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
                    <DataField 
                        editMode={false} 
                        lg={12} 
                        md={24} 
                        name="name" 
                        value={data.name} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={12} 
                        md={24} 
                        options={props.ad.RELATION_CODE} 
                        type="Select" 
                        name="relation" 
                        value={data.relation_code} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={12} 
                        md={24} 
                        name="dob" 
                        value={data.dob ? data.dob.format('DD-MM-YYYY') : null} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={12} 
                        md={24} 
                        options={props.ad.GENDER} 
                        type="Select" 
                        name="gender" 
                        value={data.gender} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={8} 
                        md={24} 
                        options={props.ad.EDUCATION} 
                        type="Select" 
                        name="education" 
                        value={data.education} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={8} 
                        md={24} 
                        name="earning" 
                        value={data.earning} 
                    />
                    <DataField 
                        editMode={false} 
                        lg={8} 
                        md={24} 
                        name="insurance" 
                        value={data.insurance_amount} 
                    />
                </Row>  
                <p></p>
            </div>
            
            );
        })
           
        :
        <>
            <p></p>
            <DependentEdit educationOptions = {props.ad.EDUCATION} relationOptions = {props.ad.RELATION_CODE} options = {props.ad.GENDER} data = {props.data} setData = {props.setData} />
        </>
    );
}

export default Dependent